var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3642_21786)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 8,
    fill: "#E6E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.082 5.68359C15.7888 5.68359 15.4984 5.74136 15.2274 5.85359C14.9565 5.96582 14.7103 6.13032 14.5029 6.3377L6.6279 14.2127C6.55612 14.2845 6.50431 14.3738 6.4776 14.4717L5.6026 17.68C5.54752 17.882 5.60488 18.098 5.7529 18.246C5.90092 18.394 6.11691 18.4514 6.31886 18.3963L9.5272 17.5213C9.62514 17.4946 9.71441 17.4428 9.78619 17.371L17.6612 9.49599C17.8686 9.28861 18.0331 9.04242 18.1453 8.77147C18.2575 8.50052 18.3153 8.21012 18.3153 7.91684C18.3153 7.62357 18.2575 7.33317 18.1453 7.06222C18.0331 6.79126 17.8686 6.54507 17.6612 6.3377C17.4538 6.13032 17.2076 5.96582 16.9367 5.85359C16.6657 5.74136 16.3753 5.68359 16.082 5.68359ZM15.6739 6.93145C15.8033 6.87785 15.942 6.85026 16.082 6.85026C16.2221 6.85026 16.3608 6.87785 16.4902 6.93145C16.6196 6.98505 16.7372 7.06361 16.8362 7.16266C16.9353 7.2617 17.0138 7.37928 17.0674 7.50868C17.121 7.63808 17.1486 7.77678 17.1486 7.91684C17.1486 8.05691 17.121 8.1956 17.0674 8.32501C17.0138 8.45441 16.9353 8.57199 16.8362 8.67103L9.07077 16.4365L6.99676 17.0021L7.5624 14.9281L15.3279 7.16266C15.4269 7.06361 15.5445 6.98505 15.6739 6.93145Z",
    fill: "#F8009E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3642_21786"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon-edit.9506a9f789c3d777a3d01930046e6253.svg";
export { ForwardRef as ReactComponent };